import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-activity-types',
  templateUrl: './activity-types.component.html',
  styleUrls: ['./activity-types.component.css']
})
export class ActivityTypesComponent implements OnInit {
    public itemsListActivityTypes: Item[] = [];

    constructor(private datatask: DataTaskService) { }

    private async loadActivityTypes() {
        this.itemsListActivityTypes = await this.datatask.Post(49, { onweb: 'ALL' });
    }

    private async init() {
        this.loadActivityTypes();
    }

    ngOnInit(): void {
        this.init();
    }
}
